import { useEffect, useMemo, useState } from 'react';

export function useScreenMediaQuery(): {
	isLessThan480: boolean;
	isLessThan640: boolean;
	isLessThan768: boolean;
	isLessThan1024: boolean;
	isLessThan1280: boolean;
	isHLessThan480: boolean;
	isHLessThan640: boolean;
	isHLessThan768: boolean;
	isHLessThan1024: boolean;
	isHLessThan1280: boolean;
} {
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHight] = useState(window.innerHeight);

	useEffect(() => {
		// use timeout to prevent recaluclating on every single frame while window is being resized. 
		// wait until user pauses in their resize to recalculate

		let waitTimeout: NodeJS.Timeout;
		const handleWindowResize = (): void => {
			if (waitTimeout) clearTimeout(waitTimeout);
			// wait 4 frames before updating the size
			waitTimeout = setTimeout(() => {
				setWidth(window.innerWidth);
				setHight(window.innerHeight);
			}, 64);
		};
		window.addEventListener('resize', handleWindowResize);
		return (): void => window.removeEventListener('resize', handleWindowResize);
	}, [setWidth]);

	//switched from < to <= to align with the media queries we use
	return useMemo(() => ({
		isLessThan480: width < 480,
		isLessThan640: width < 640,
		isLessThan768: width < 768,
		isLessThan1024: width < 1024,
		isLessThan1280: width < 1280,
		isHLessThan480: height <= 480,
		isHLessThan640: height <= 640,
		isHLessThan768: height <= 768,
		isHLessThan1024: height <= 1024,
		isHLessThan1280: height <= 1280,
	}), [width, height]);
}